import React from 'react';
import useTeamStyles from './styles';
import NextImageRenderer from '../../components/nextImageRenderer';
import RankIcon from '../../assets/images/medal-star.svg';
import Book from '../../assets/images/book-saved.svg';
import Teacher from '../../assets/images/teacher.svg';
import StarIcon from '../../assets/images/star.svg';

const SingleSlide = ({ data, sectionIndex, fullWidth, isMobile }) => {
  const classes = useTeamStyles();

  return (
    <div
      className={classes.singleSlideContainer}
      style={
        isMobile
          ? { width: 'calc(100% - 16px)' }
          : fullWidth
          ? { width: 'calc(100% - 24px)' }
          : { width: 'calc(25% - 24px)' }
      }
    >
      <div className={classes.imageContainer}>
        {/* <img
          ref={data?.image?.refSetter}
          className={classes.image}
          alt="Hero Image"
          src={data.image.metadata.value}
        /> */}

        {data?.teamSlideStarTutor?.metadata?.value ? (
          <span className={classes.starTag}>
            <img src={StarIcon} />
            <span className={classes.starTagText}>Star Tutor</span>
          </span>
        ) : null}

        <NextImageRenderer
          ref={data?.image?.refSetter}
          className={classes.image}
          alt="Hero Image"
          src={data.image.metadata.value}
          sectionIndex={sectionIndex}
        />
      </div>

      <div className={classes.teamDetailsContainer}>
        <h3
          ref={data?.teamSlideTitle?.refSetter}
          className={classes.teamDetailsHeading}
          dangerouslySetInnerHTML={{
            __html: data.teamSlideTitle.metadata.value
          }}
        />

        {data?.teamSlideSubTitle?.metadata?.value ? (
          <div
            ref={data?.teamSlideSubTitle?.refSetter}
            className={classes.teamDetailsSubHeading}
            dangerouslySetInnerHTML={{
              __html: data.teamSlideSubTitle.metadata.value
            }}
          />
        ) : null}

        {data?.teamSlideYearOfExperience?.metadata?.value ? (
          <div className={classes.subHeadingWrapper}>
            <img src={RankIcon} />
            <div
              ref={data?.teamSlideYearOfExperience?.refSetter}
              className={classes.teamDetailsSubHeading}
              dangerouslySetInnerHTML={{
                __html: data.teamSlideYearOfExperience.metadata.value
              }}
            />
          </div>
        ) : null}

        {data?.teamSlideSpecialisation?.metadata?.value ? (
          <div className={classes.subHeadingWrapper}>
            <img src={Book} />
            <div
              ref={data?.teamSlideSpecialisation?.refSetter}
              className={classes.teamDetailsSubHeading}
              dangerouslySetInnerHTML={{
                __html: data.teamSlideSpecialisation.metadata.value
              }}
            />
          </div>
        ) : null}

        {data?.teamSlideQualification?.metadata?.value ? (
          <div className={classes.subHeadingWrapper}>
            <img src={Teacher} />
            <div
              ref={data?.teamSlideQualification?.refSetter}
              className={classes.teamDetailsSubHeading}
              dangerouslySetInnerHTML={{
                __html: data.teamSlideQualification.metadata.value
              }}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default SingleSlide;
